import React, { useEffect, useRef } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { getAllCareersAsync, CareersActions } from "../redux";
import CareersTable from "./careersDetail/careersTable";
import {
  Card,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import { useIsAccessAllow } from "../../users/redux";

export function WebcluesCareers() {
  const dispatch = useDispatch();
  const history = useHistory();
  const searchRef = useRef();
  const { refreshCareers, searchBy, searchText } = useSelector(
    (state) => state.webcluescareers,
    shallowEqual
  );

  useEffect(() => {
    if (searchRef.current) {
      let keyPressEvent = (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          dispatch(CareersActions.refreshCareersList());
        }
      };
      let input = searchRef.current;
      input.addEventListener("keyup", keyPressEvent);

      return () => {
        input.removeEventListener("keyup", keyPressEvent);
        dispatch(CareersActions.searchTextChange(""));
        input.value = "";
      };
    }
  }, [dispatch]);

  useEffect(() => {
    if (refreshCareers) {
      dispatch(getAllCareersAsync(searchBy, searchText));
    }
    // eslint-disable-next-line
  }, [refreshCareers]);

  const onSearchTextChange = (e) => {
    dispatch(CareersActions.searchTextChange(e.target.value));
  };

  const onSelectCareers = (careers) => {
    history.push(`/webclues_careers/add-careers`);
  };
  const isAddCareersAllow = useIsAccessAllow("webclues_careers.add_careers");
  const isSearchAllow = useIsAccessAllow("webclues_careers.list");

  return (
    <>
      <Card>
        <CardHeader title="Webclues Careers">
          <CardHeaderToolbar>
            <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
              <form
                className="subheader_filter"
                onSubmit={(e) => e.preventDefault()}
              >
                <div className="form-row">
                  {isAddCareersAllow && (
                    <div className="form-group mr-5 mb-1 mt-2">
                      <button
                        className="btn_new btn-sm"
                        type="button"
                        onClick={() => onSelectCareers()}
                      >
                        Add
                      </button>
                    </div>
                  )}
                  {isSearchAllow && (
                    <div className="form-group mr-3 mb-1">
                      <input
                        name="Search"
                        placeholder="Search. . ."
                        type="text"
                        className="form-control"
                        value={searchText}
                        autoComplete="off"
                        onChange={onSearchTextChange}
                        ref={searchRef}
                      />
                    </div>
                  )}
                </div>
              </form>
            </div>
          </CardHeaderToolbar>
        </CardHeader>
        <CareersTable />
      </Card>
    </>
  );
}
